import { render, staticRenderFns } from "./ShowEchange.vue?vue&type=template&id=be225bc6&scoped=true&"
import script from "./ShowEchange.vue?vue&type=script&lang=js&"
export * from "./ShowEchange.vue?vue&type=script&lang=js&"
import style0 from "./ShowEchange.vue?vue&type=style&index=0&id=be225bc6&lang=scss&scoped=true&"
import style1 from "./ShowEchange.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be225bc6",
  null
  
)

export default component.exports